var React = require('react');

function Active (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM1 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z","fill":"#BEC4CF"}));
}

Active.defaultProps = {"width":"10","height":"2","viewBox":"0 0 10 2"};

module.exports = Active;

Active.default = Active;
